import * as React from 'react';

import { ELandStatusType, getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { LandStatus } from '../../../components/advancedFilters/LandStatus';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const LandStatusContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const landStatus = getTermsValue('land_status')(jsonQuery);

  const handleChange = React.useCallback(
    (landStatus: NonEmptyArray<ELandStatusType> | null) => {
      onChange({ action: 'setLandStatusTypes', arguments: [landStatus] });
    },
    [onChange],
  );

  return <LandStatus value={landStatus as NonEmptyArray<ELandStatusType> | null} onChange={handleChange} />;
};
